import { adSlots } from "../../../mocks/adminData";

const STATUS_CONFIG = {
  active: { label: "Aktif",     class: "bg-emerald-100 text-emerald-700", dot: "bg-emerald-500" },
  paused: { label: "Beklemede", class: "bg-amber-100 text-amber-700",    dot: "bg-amber-500" },
  ended:  { label: "Sona Erdi", class: "bg-stone-100 text-stone-500",    dot: "bg-stone-300" },
};

export default function AdsSection() {
  const totalImpressions = adSlots.reduce((s, a) => s + a.impressions, 0);
  const totalClicks = adSlots.reduce((s, a) => s + a.clicks, 0);
  const avgCtr = totalImpressions > 0 ? ((totalClicks / totalImpressions) * 100).toFixed(2) : "0.00";
  const totalBudget = adSlots.reduce((s, a) => s + a.budget, 0);

  return (
    <div className="space-y-5">
      {/* Summary stats */}
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        {[
          { label: "Toplam Gösterim",  value: totalImpressions.toLocaleString(), icon: "ri-eye-line",         color: "bg-sky-50 text-sky-700" },
          { label: "Toplam Tıklama",   value: totalClicks.toLocaleString(),       icon: "ri-cursor-line",      color: "bg-emerald-50 text-emerald-700" },
          { label: "Ort. CTR",         value: `%${avgCtr}`,                       icon: "ri-percent-line",     color: "bg-amber-50 text-amber-700" },
          { label: "Toplam Bütçe",     value: `₺${totalBudget.toLocaleString()}`, icon: "ri-money-euro-circle-line", color: "bg-violet-50 text-violet-700" },
        ].map((s) => (
          <div key={s.label} className="bg-white rounded-2xl p-4 border border-stone-100">
            <div className={`w-9 h-9 flex items-center justify-center rounded-xl mb-3 ${s.color}`}>
              <i className={`${s.icon} text-base`} />
            </div>
            <div className="text-2xl font-bold text-stone-800 mb-0.5">{s.value}</div>
            <div className="text-xs text-stone-400">{s.label}</div>
          </div>
        ))}
      </div>

      {/* Ad Slots */}
      <div className="flex items-center justify-between">
        <h3 className="font-semibold text-stone-800">Reklam Kampanyaları</h3>
        <button className="flex items-center gap-2 bg-emerald-700 hover:bg-emerald-800 text-white px-4 py-2 rounded-xl text-sm font-semibold transition-colors cursor-pointer whitespace-nowrap">
          <i className="ri-add-line" /> Reklam Ekle
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
        {adSlots.map((ad) => {
          const statConf = STATUS_CONFIG[ad.status];
          const ctr = ad.impressions > 0 ? ((ad.clicks / ad.impressions) * 100).toFixed(2) : "0.00";
          return (
            <div key={ad.id} className="bg-white rounded-2xl border border-stone-100 overflow-hidden">
              <div className="relative h-32 overflow-hidden">
                <img src={ad.image} alt={ad.title} className="w-full h-full object-cover object-top" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent" />
                <div className="absolute top-3 right-3">
                  <span className={`flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-semibold ${statConf.class}`}>
                    <span className={`w-1.5 h-1.5 rounded-full ${statConf.dot}`} />
                    {statConf.label}
                  </span>
                </div>
                <div className="absolute bottom-3 left-3">
                  <p className="text-white font-bold text-sm">{ad.title}</p>
                  <p className="text-white/70 text-xs">{ad.advertiser} · {ad.placement}</p>
                </div>
              </div>

              <div className="p-4">
                {/* Stats row */}
                <div className="grid grid-cols-3 gap-3 mb-4 text-center">
                  <div className="bg-stone-50 rounded-xl p-2">
                    <div className="text-sm font-bold text-stone-700">{ad.impressions.toLocaleString()}</div>
                    <div className="text-xs text-stone-400">Gösterim</div>
                  </div>
                  <div className="bg-stone-50 rounded-xl p-2">
                    <div className="text-sm font-bold text-stone-700">{ad.clicks.toLocaleString()}</div>
                    <div className="text-xs text-stone-400">Tıklama</div>
                  </div>
                  <div className="bg-stone-50 rounded-xl p-2">
                    <div className="text-sm font-bold text-stone-700">%{ctr}</div>
                    <div className="text-xs text-stone-400">CTR</div>
                  </div>
                </div>

                {/* Date + Budget */}
                <div className="flex items-center justify-between text-xs text-stone-500 mb-3">
                  <span><i className="ri-calendar-line mr-1 text-stone-400" />{ad.startDate} – {ad.endDate}</span>
                  <span className="font-semibold text-stone-700">₺{ad.budget.toLocaleString()}</span>
                </div>

                {/* Actions */}
                <div className="flex gap-2">
                  <button className="flex-1 flex items-center justify-center gap-1.5 py-2 border border-stone-200 rounded-xl text-xs font-medium text-stone-600 hover:bg-stone-50 transition-colors cursor-pointer whitespace-nowrap">
                    <i className="ri-edit-line" /> Düzenle
                  </button>
                  <button className={`flex-1 flex items-center justify-center gap-1.5 py-2 rounded-xl text-xs font-medium transition-colors cursor-pointer whitespace-nowrap ${
                    ad.status === "active"
                      ? "border border-amber-200 text-amber-600 hover:bg-amber-50"
                      : "border border-emerald-200 text-emerald-600 hover:bg-emerald-50"
                  }`}>
                    <i className={`${ad.status === "active" ? "ri-pause-line" : "ri-play-line"}`} />
                    {ad.status === "active" ? "Durdur" : "Başlat"}
                  </button>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
